(function () {
  // Keeps the theme's price displays (snippets/price.liquid, used both by
  // the main product info block and the sticky-atc-bar section) — and the
  // sticky bar's own add-to-cart form — in sync with the real Loop
  // Subscriptions widget. Neither has any built-in awareness of selling
  // plans: the price displays kept showing the one-time price after
  // switching to "Abonnieren und sparen", and the sticky bar's form has no
  // selling_plan field at all, so submitting it always added a one-time
  // purchase regardless of what was selected. This reads Loop's own
  // per-variant/per-selling-plan pricing data (already present in
  // window.LOOP_WIDGET on every product page that has the widget), updates
  // every price block's text, and mirrors the active selling plan into a
  // dynamically added hidden field on the sticky bar's form. No-op entirely
  // on pages without the widget.
  //
  // sticky-atc-bar.js runs its own (subscription-unaware) price update on
  // the same "variant:changed" event, which would otherwise overwrite ours
  // if it happened to run after — updates here are deferred a tick so this
  // always has the last word.

  function getLoopProduct() {
    const container = document.querySelector('[id^="loop-widget-container-id-"]');
    if (!container || !window.LOOP_WIDGET) return null;
    const productId = container.id.replace('loop-widget-container-id-', '');
    return window.LOOP_WIDGET[productId]?.product || null;
  }

  function formatMoney(cents) {
    if (window.FoxTheme?.Currency?.formatMoney) {
      return window.FoxTheme.Currency.formatMoney(cents, window.FoxTheme.settings?.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  // Liest die aktive Selling-Plan-ID aus dem versteckten Formularfeld, das
  // Loop für den echten Add-to-Cart-Request setzt. Das funktioniert auch für
  // Produkte, die nur ein Lieferintervall haben und daher gar keine
  // Intervall-Buttons rendern (dort gibt es kein .loop-widget-sp-button-Element
  // zum Auslesen, aber dieses Feld existiert trotzdem). Leer/kein Wert bedeutet
  // Einmalkauf ist aktiv.
  function getSelectedSellingPlanId() {
    const input = document.querySelector('input[name="selling_plan"]');
    if (input && input.value) return Number(input.value);

    const checkedButton = document.querySelector('.loop-widget-sp-button[aria-checked="true"]');
    return checkedButton ? Number(checkedButton.dataset.sellingPlanId) : null;
  }

  function setText(el, text) {
    if (el) el.textContent = text;
  }

  // Aktualisiert sowohl "<s>Preis</s>" (Hauptblock) als auch reinen Text ohne
  // <s> (Sticky-Bar baut ihr Markup selbst neu auf, ohne <s>-Tag).
  function setCompareText(el, text) {
    if (!el) return;
    const s = el.querySelector('s');
    setText(s || el, text);
  }

  function updatePriceBlock(priceBlock, product) {
    const scope = priceBlock.closest('product-info, sticky-atc-bar') || document;
    const variantField = scope.querySelector('[name="id"]');
    const variant = variantField
      ? product.variants.find((v) => v.id === Number(variantField.value))
      : null;
    if (!variant) return;

    let price = variant.price;
    let unitPrice = variant.unit_price;
    // Immer den regulären UVP der Variante als Vergleichspreis zeigen, nicht
    // den compare_at_price der Selling-Plan-Allocation (das ist bei Shopify
    // der Einmalkauf-Preis, nicht der UVP) — sonst zeigt der durchgestrichene
    // Preis nur die zusätzliche Abo-Ersparnis statt der Gesamtersparnis, was
    // nicht zu Loops "Sie sparen X%"-Badge passt.
    const compareAtPrice = variant.compare_at_price;

    const sellingPlanId = getSelectedSellingPlanId();
    if (sellingPlanId) {
      const allocation = variant.selling_plan_allocations?.find(
        (a) => a.selling_plan_id === sellingPlanId
      );
      if (allocation) {
        price = allocation.price;
        unitPrice = allocation.unit_price;
      }
    }

    const onSale = Boolean(compareAtPrice && compareAtPrice > price);
    priceBlock.classList.toggle('f-price--on-sale', onSale);

    const formattedPrice = formatMoney(price);
    setText(priceBlock.querySelector('.f-price__regular .f-price-item--regular'), formattedPrice);
    setText(priceBlock.querySelector('.f-price__sale .f-price-item--sale'), formattedPrice);

    if (compareAtPrice) {
      setCompareText(priceBlock.querySelector('.f-price__sale .f-price-item--regular'), formatMoney(compareAtPrice));
    }

    if (unitPrice) {
      const unitEl =
        priceBlock.querySelector('[data-unit-price]') ||
        priceBlock.querySelector('.f-price__unit span:first-child');
      setText(unitEl, formatMoney(unitPrice));
    }
  }

  // Die Sticky-Bar hat ihr eigenes Add-to-Cart-Formular ohne selling_plan-Feld
  // und würde beim Absenden daher immer den Einmalkauf bestellen, egal was im
  // Loop-Widget ausgewählt ist. Hier wird das Feld dynamisch nachgezogen —
  // nur wenn der Plan auch zur in der Sticky-Bar gewählten Variante passt
  // (unterschiedliche Varianten haben unterschiedliche Selling-Plan-IDs für
  // "dasselbe" Intervall), sonst bleibt es beim Einmalkauf statt eine
  // ungültige Kombination zu senden.
  function syncStickyBarSellingPlan(product) {
    const stickyForm = document.querySelector('#product-form-sticky-atc-bar');
    if (!stickyForm) return;

    let input = stickyForm.querySelector('input[name="selling_plan"]');
    const sellingPlanId = getSelectedSellingPlanId();

    if (!sellingPlanId) {
      input?.remove();
      return;
    }

    const variantField = stickyForm.querySelector('[name="id"]');
    const variant = variantField
      ? product.variants.find((v) => v.id === Number(variantField.value))
      : null;
    const validForVariant = variant?.selling_plan_allocations?.some(
      (a) => a.selling_plan_id === sellingPlanId
    );

    if (!validForVariant) {
      input?.remove();
      return;
    }

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      stickyForm.appendChild(input);
    }
    input.value = sellingPlanId;
  }

  function syncAll() {
    const product = getLoopProduct();
    if (!product) return;
    document.querySelectorAll('.f-price').forEach((priceBlock) => updatePriceBlock(priceBlock, product));
    syncStickyBarSellingPlan(product);
  }

  function init() {
    const container = document.querySelector('[id^="loop-widget-container-id-"]');
    if (!container) return;

    syncAll();

    new MutationObserver(syncAll).observe(container, {
      attributes: true,
      attributeFilter: ['aria-checked'],
      subtree: true,
      childList: true,
    });
    document.addEventListener('click', () => setTimeout(syncAll, 50));
    document.addEventListener('variant:changed', () => setTimeout(syncAll, 50));
  }

  init();
})();
